import "../css/style.scss";
import { Common } from "./common";
var common = new Common();
common.setInitialDoc("tcpp");
common.langClick("tcpp");
